module.exports = __webpack_public_path__ + "static/media/ottawa-39.89d8028c.jpg";